import type { Building } from "building-types/building/buildingTypes";
import { sanitizeOptionChoices } from "doc/options/optionChoicesTools";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

type SelectReturnType = ReturnType<typeof select>;

function select({
  doc: { optionTemplates, optionSetOverrides, optionSets, optionLocks, instanceOptionSets },
  optionChoices,
}: Building) {
  return {
    optionTemplates,
    optionSetOverrides,
    optionLocks,
    optionSets,
    instanceOptionSets,
    optionChoices,
  };
}

const compare = makeGenerationStageComparator<typeof select>({
  optionChoices: "shallow",
});

function generate({
  optionTemplates,
  optionSetOverrides,
  optionLocks,
  optionSets,
  instanceOptionSets,
  optionChoices,
}: SelectReturnType): Pick<Building, "optionChoices"> {
  return {
    optionChoices: sanitizeOptionChoices(
      { optionLocks, optionSetOverrides, optionTemplates, optionSets, instanceOptionSets },
      optionChoices,
    ),
  };
}

export default memo(select, generate, compare);
